// extracted by mini-css-extract-plugin
export default {"App":"App_App__27swo","App-logo":"App_App-logo__1OXo0","App-logo-spin":"App_App-logo-spin__QIud8","App-header":"App_App-header__B6vLT","App-link":"App_App-link__EOec+"};